import { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import ErrorModal from "../../components/ErrorModal";
import handleApiError from "../../../utils/handleApiError";
import SuccessModal from "../../components/SuccessModal";
import axios from "../../../axios";
import GrafikPenjualan from "./GrafikPenjualan";
import PurchaseLeaderboards from "./PurchaseLeaderboards";
import BestProduct from "./BestProduct";
// import FaqForm from "./FaqForm";

export default function DashboardPage() {
    const [form, setForm] = useState({
        question: "",
        answer: "",
    });

    const navigate = useNavigate();
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");
    const [loading, setLoading] = useState(false);

    const [leaderboardPenjualan, setLeaderboardPenjualan] = useState([]);
    const [bestProduct, setBestProduct] = useState([]);

    // const handleSubmit = async (e) => {
    //     setLoading(true);

    //     e.preventDefault();
    //     setError("");

    //     try {
    //         await axios.post("/admin/faqs", form);
    //         setSuccess("Data berhasil ditambahkan!");
    //     } catch (err) {
    //         setError(handleApiError(err));
    //     } finally {
    //         setLoading(false);
    //     }
    // };

    useEffect(() => {
        fetchSalesLeaderboards();
        fetchSalesBestProduct();
    }, []);

    const fetchSalesLeaderboards = async () => {

        setError("");

        try {

            const res = await axios.get("/admin/sales-report/customers");
            setLeaderboardPenjualan(res.data);
            
        } catch (err) {
            setError(handleApiError(err));
        } finally {
            setLoading(false);
        }
    };

    const fetchSalesBestProduct = async () => {

        setError("");

        try {

            const res = await axios.get("/admin/sales-report/best-products");
            setBestProduct(res.data);
            
        } catch (err) {
            setError(handleApiError(err));
        } finally {
            setLoading(false);
        }
    };

    // const fetchSalesGrafik = async () => {

    //     setError("");

    //     try {

    //         const res = await axios.get("/admin/sales-report/best-products");
    //         setBestProduct(res.data);
            
    //     } catch (err) {
    //         setError(handleApiError(err));
    //     } finally {
    //         setLoading(false);
    //     }
    // };


    return (
        <>
            <Link to="/admin/faqs" className=" mt-3">Kembali</Link>
            <ErrorModal error={error} onClose={() => setError("")} />
            <SuccessModal
                message={success}
                onClose={() => {
                    setSuccess("");
                    navigate("/admin/faqs");
                }}
            />
            <div class="row gy-4">
            <GrafikPenjualan  />
            <PurchaseLeaderboards data={leaderboardPenjualan} />
            <BestProduct data={bestProduct} />
            </div>
        </>
    );
}
